import { QueryString } from "@grandvisionhq/utils";
const getFormattedParams = ({
  storeId,
  typeId,
  linkedAppointmentTypeId,
  alternativeLinkedAppointmentTypeId,
  start,
  end,
  appointmentId,
  virtualStoreCode,
  virtualAppointmentTypeId,
  alternativeUrlStores,
  tryInStoreFlow,
  tryInStoreProductSkus,
  groupId
}) => ({
  storeId: storeId !== void 0 ? parseInt(storeId, 10) : void 0,
  globalStoreId: storeId,
  typeId,
  linkedAppointmentTypeId,
  alternativeLinkedAppointmentTypeId,
  start: start?.length ? start : void 0,
  end: end?.length ? end : void 0,
  appointmentId: appointmentId ?? void 0,
  virtualStoreCode: virtualStoreCode !== void 0 ? parseInt(virtualStoreCode, 10) : void 0,
  virtualAppointmentTypeId,
  alternativeUrlStores: alternativeUrlStores?.split(",").map((string) => string),
  tryInStoreFlow: tryInStoreFlow ? true : void 0,
  tryInStoreProductSkus: tryInStoreProductSkus?.split(",").map((string) => string),
  groupId: groupId && groupId !== "null" ? groupId : void 0
});
const hasValidVirtualAppointmentConfig = (params) => params.virtualStoreCode !== void 0 && params.virtualAppointmentTypeId !== void 0;
const hasValidVirtualAppointmentParams = (params) => hasValidVirtualAppointmentConfig(params) && params.typeId === params.virtualAppointmentTypeId && params.storeId === params.virtualStoreCode;
const hasInvalidVirtualAppointmentParams = (params) => hasValidVirtualAppointmentConfig(params) && (params.typeId === params.virtualAppointmentTypeId && params.storeId !== params.virtualStoreCode || params.typeId !== params.virtualAppointmentTypeId && params.storeId === params.virtualStoreCode);
const replaceCurrentRoute = (baseUrl, asPath, currentRoute, newRoute, queryParams) => {
  const cleanAsPath = asPath.replace(currentRoute, newRoute).split("?")[0];
  const clearQueryParameters = QueryString.stringify(
    queryParams,
    Object.entries(queryParams).length === 0
  );
  return `${baseUrl}${cleanAsPath}${clearQueryParameters}`;
};
const isAppointmentTypeValid = ({ store, typeId }) => Boolean(store?.appointmentTypes?.find(({ id }) => id === typeId));
const generateVirtualAppointmentStoreData = (code, virtualAppointmentType) => ({
  code,
  globalStoreId: "0",
  // TODO: MACC-19077 Remove before merged to master.
  name: "[placeholder-virtual-appointment-store-name]",
  shortName: "[placeholder-virtual-appointment-store-short-name]",
  streetName: "[placeholder-virtual-appointment-store-street-name]",
  streetNumber: void 0,
  additionalStreetInfo: void 0,
  postalCode: void 0,
  province: void 0,
  town: "[placeholder-virtual-appointment-store-town]",
  country: "[placeholder-virtual-appointment-store-country]",
  lat: void 0,
  lon: void 0,
  phone: "[placeholder-virtual-appointment-store-phone]",
  emailAddress: void 0,
  appointmentTypes: [virtualAppointmentType]
});
const generateVirtualAppointmentStoreByIdData = (globalStoreId, virtualAppointmentType) => ({
  code: 0,
  // TODO: MACC-19077 Remove before merged to master.
  globalStoreId: globalStoreId.toString(),
  // TODO: MACC-19077 Remove before merged to master.
  name: "[placeholder-virtual-appointment-store-name]",
  shortName: "[placeholder-virtual-appointment-store-short-name]",
  streetName: "[placeholder-virtual-appointment-store-street-name]",
  streetNumber: void 0,
  additionalStreetInfo: void 0,
  postalCode: void 0,
  province: void 0,
  town: "[placeholder-virtual-appointment-store-town]",
  country: "[placeholder-virtual-appointment-store-country]",
  lat: void 0,
  lon: void 0,
  phone: "[placeholder-virtual-appointment-store-phone]",
  emailAddress: void 0,
  appointmentTypes: [virtualAppointmentType]
});
export {
  generateVirtualAppointmentStoreByIdData,
  generateVirtualAppointmentStoreData,
  getFormattedParams,
  hasInvalidVirtualAppointmentParams,
  hasValidVirtualAppointmentConfig,
  hasValidVirtualAppointmentParams,
  isAppointmentTypeValid,
  replaceCurrentRoute
};
//# sourceMappingURL=utils.js.map
